import React, {useEffect, useState} from "react";
import {Button, Card, CardBody, Col, Container, Input, Row, Tooltip} from "reactstrap";
import CommanDataTable from "../../../Components/Common/DataTable";
import {APIClient} from "../../../helpers/api_helper";
import { GET_APP_VERSION} from "../../../helpers/url_helper";
import {ToastContainer} from "react-toastify";
import {HandleErrorMessage} from "../../../Components/Common/HandleErrorMessage";
import moment from "moment";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import {useLocation, useNavigate} from "react-router-dom";
import {FaRegCopy} from "react-icons/fa";
import { exportToExcel, exportToPDF } from "../../../Components/Common/exportUtils";
import { CommanDataTables } from "../../../Components/Common/DashboardDataTbale";

const api = new APIClient();

const AppVersion = () => {
    const navigate = useNavigate();
    const location = useLocation();
    // Row-specific tooltip state
    const reportTitle = "App Version";

    const loginType = JSON.parse(localStorage.getItem("logintype"));
    const [isLoading, setIsLoading] = useState(true);
    const [totalRows, setTotalRows] = useState(0);
    const [perPage, setPerPage] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);
    const [employeeData, setEmployeeData] = useState([]);
    const [searchQuery, setSearchQuery] = useState("");
    const [debouncedQuery, setDebouncedQuery] = useState("");
    // const [query, setQuery] = useState("");
    //For URL encoding
    const decodeUrlEncoded = (encodedString) => {
        if (!encodedString) return "-"; // Handle empty cases
        try {
            return decodeURIComponent(encodedString);
        } catch (e) {
            console.error("Error decoding URL:", e);
            return encodedString; // Return original if decoding fails
        }
    };
    const [tooltipOpen, setTooltipOpen] = useState(false); // Move state inside
    const [openTooltipId, setOpenTooltipId] = useState(null); // Track open tooltip ID

    const [copiedText, setCopiedText] = useState(null);
 

  // Function to Copy Text to Clipboard
  const handleCopy = (text, id) => {
    if (!text) return; // Prevent copying empty text

    // Try to use Clipboard API
    if (navigator.clipboard) {
      navigator.clipboard
        .writeText(text)
        .then(() => {
          setCopiedText(id);
          setTimeout(() => setCopiedText(null), 2000); // Reset after 2s
        })
        .catch((err) => console.error("Clipboard API failed:", err));
    } else {
      // Fallback for older browsers
      const textArea = document.createElement("textarea");
      textArea.value = text;
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand("copy");
      document.body.removeChild(textArea);

      setCopiedText(id);
      setTimeout(() => setCopiedText(null), 2000);
    }
  };

  // Function to Toggle Tooltip
  const toggleTooltip = (id) => {
    setOpenTooltipId(openTooltipId === id ? null : id);
  };

   const headers = [
          { label: "SN.", key: "serialNumber" },
          { label: "Employee Name", key: "fullName" },
          { label: "Device Name", key: "deviceName" },
          { label: "App Version", key: "appVersion" },
          { label: "Last Call Sync Time", key: "lastCallSync" },
          { label: "Last Recording Sync Time", key: "lastCallRecordingSync" },
          { label: "Last App Open Time", key: "appVersionUpdate" },
          { label: "Activity Status", key: "todayActiveStatus" },
          { label: "Recording Path", key: "recordingStoragePath" },
      ];
  
  
      const handleExcelExport = async () => {
          await exportToExcel(employeeData, headers, reportTitle,"app_version","App Version")
      }
  
    const columns = [
        {
            name: <span className="font-weight-bold fs-13">S.No</span>,
            selector: (row, index) => index + 1, // Serial number based on index
            cell: (row, index) => <span>{index + 1}</span>, // Display serial number
            sortable: false,
            width: "5%",
        },
        {
            name: <span className="font-weight-bold fs-13">Employee Name</span>,
            selector: (row) => row.fullName,
            cell: (row) => (
                <div className="d-flex align-items-center w-100" style={{textTransform: "capitalize"}}>
                    <span style={{flexGrow: 1}}>{row.fullName}</span>
                    <span
                        style={{
                            color: row.todayActiveStatus === 1 ? "green" : "red",
                            marginLeft: "10px",
                        }}
                    >
                        <div>
                            <span
                                className={`d-inline-block rounded-circle ${
                                    row.todayActiveStatus === 1 ? "bg-success" : "bg-danger"
                                }`}
                                style={{width: "10px", height: "10px"}}
                            ></span>
                        </div>
                    </span>
                </div>
            ),
            sortable: true,
            width: "220px",
        },
        {
            name: <span className="font-weight-bold fs-13">Device Name</span>,
            selector: (row) => row.deviceName,
            cell: (row) => <span>{row.deviceName || "-"}</span>,
            sortable: true,
            width:'150px'
        },
        {
            name: <span className="font-weight-bold fs-13">App Version</span>,
            selector: (row) => row.appVersion || "",
            cell: (row) => <span>{row.appVersion || "-"}</span>,
            sortable: true,
        },
        {
            name: <span className="font-weight-bold fs-13">Last Call Sync Time</span>,
            selector: (row) => {
                const isSame = moment(row?.lastCallSync).isSame(moment(row?.createdAt), "second");
                return isSame ? (
                    "-"
                ) : (
                    <>
                        {moment(row.lastCallSync).format("DD MMM YYYY")}
                        <br />
                        {moment(row.lastCallSync).format("hh:mm:ss A")}
                    </>
                );
            },
            sortable: true,
            sortFunction: (a, b) => {
                const dateA = new Date(a.lastCallSync);
                const dateB = new Date(b.lastCallSync);
                return dateB - dateA;
            },
            width: "172px",
        },

        {
            name: <span className="font-weight-bold fs-13">Last Recording Sync Time</span>,
            selector: (row) => {
                const isSame = moment(row?.lastCallRecordingSync).isSame(moment(row?.createdAt), "second");
                return isSame ? (
                    "-"
                ) : (
                    <>
                        {moment(row?.lastCallRecordingSync).format("DD MMM YYYY")}
                        <br />
                        {moment(row?.lastCallRecordingSync).format("hh:mm:ss A")}
                    </>
                );
            },
            sortable: true,
            sortFunction: (a, b) => {
                const dateA = new Date(a.lastCallRecordingSync);
                const dateB = new Date(b.lastCallRecordingSync);
                return dateB - dateA;
            },
            width: "180px",
        },
        {
            name: <span className="font-weight-bold fs-13">Last App Open Time</span>,
            selector: (row) =>
                row?.appVersionUpdate ? (
                    <>
                        {moment(row?.appVersionUpdate).format("DD MMM YYYY")}
                        <br />
                        {moment(row?.appVersionUpdate).format("hh:mm:ss A")}
                    </>
                ) : (
                    "-" // Show "-" if appVersionUpdate is not present
                ),
            sortable: true,
            sortFunction: (a, b) => {
                const dateA = new Date(a.appVersionUpdate);
                const dateB = new Date(b.appVersionUpdate);
                return dateB - dateA;
            },
            width: "172px",
        },
        {
            name: <span className="font-weight-bold fs-13">Activity Status</span>,
            selector: (row) => row.todayActiveStatus,
            cell: (row) => <span>{row.todayActiveStatus === 1 ? "Active" : "Inactive"}</span>,
            sortable: true,
        },
        // {
        //   name: <span className="font-weight-bold fs-13">Recording Path</span>,
        //   selector: (row) => row.recordingStoragePath,
        //   cell: (row) => (
        //    <div className="sn-app-version-see-more-txt">
        //      <span>
        //       {row.recordingStoragePath && row.recordingStoragePath.length > 20 ? (
        //         <>
        //           {row.showFullPath
        //             ? decodeUrlEncoded(row.recordingStoragePath)
        //             : `${decodeUrlEncoded(row.recordingStoragePath).slice(
        //               0,
        //               20
        //             )}... `}
        //           <Button
        //             color="link"
        //             onClick={() => {
        //               setEmployeeData((prevData) =>
        //                 prevData.map((emp) =>
        //                   emp._id === row._id
        //                     ? { ...emp, showFullPath: !emp.showFullPath }
        //                     : emp
        //                 )
        //               );
        //             }}
        //           >
        //             {row.showFullPath ? "See Less" : "See More"}
        //           </Button>
        //         </>
        //       ) : (
        //         decodeUrlEncoded(row.recordingStoragePath) || "-"
        //       )}
        //     </span>
        //    </div>
        //   ),

        //   sortable: true,
        // },

        {
            name: <span className="font-weight-bold fs-13">Recording Path</span>,
            selector: (row) => row.recordingStoragePath,
            cell: (row) => {
                return (
                  <div
                    className="recording-path-section-tble"
                    style={{
                      width: "100%",
                      textAlign: "left",
                      overflowX: "auto",
                      whiteSpace: "nowrap",
                    }}
                  >
                    <span className="recording-path-text">
                      {row.recordingStoragePath && row.recordingStoragePath.length > 20 ? (
                        <>
                          {row.showFullPath
                            ? decodeUrlEncoded(row.recordingStoragePath)
                            : `${decodeUrlEncoded(row.recordingStoragePath).slice(0, 20)}... `}
                          
                          <div style={{ display: "flex", alignItems: "center" }}>
                            {/* See More / See Less Button */}
                            <Button
                              color="link"
                              className="recording-path-toggle-btn"
                              id={`tooltip-${row._id}`}
                              onClick={() => toggleTooltip(row._id)}
                              onMouseEnter={() => toggleTooltip(row._id)}
                              onMouseLeave={() => setOpenTooltipId(null)}
                              style={{ paddingLeft: "0" }}
                            >
                              {row.showFullPath ? "See Less" : "See More"}
                            </Button>
          
                            {/* Copy Icon */}
                            <FaRegCopy
                              className="copy-icon"
                              onClick={() =>
                                handleCopy(decodeUrlEncoded(row.recordingStoragePath), row._id)
                              }
                              style={{
                                cursor: "pointer",
                                marginLeft: "5px",
                                color: "#f17171",
                              }}
                              title="Copy to Clipboard"
                            />
                            <span style={{ marginLeft: "5px", color: "#28a745" }}>
                              {copiedText === row._id ? "Copied!" : ""}
                            </span>
                          </div>
          
                          {/* Tooltip */}
                          <Tooltip
                            placement="top"
                            isOpen={openTooltipId === row._id}
                            target={`tooltip-${row._id}`}
                            toggle={() => toggleTooltip(row._id)}
                            autohide={true}
                            delay={{ show: 100, hide: 200 }}
                          >
                            {decodeUrlEncoded(row.recordingStoragePath)}
                          </Tooltip>
                        </>
                      ) : (
                        decodeUrlEncoded(row.recordingStoragePath) || "-"
                      )}
                    </span>
                  </div>
                );
              },
              sortable: true,
              width: "250px",
            },
    ];

    const fetchData = async (query) => {
        setIsLoading(true);
        try {
            const response  = await api.get(
                    `${GET_APP_VERSION}?pg=${currentPage}&lm=${perPage}&query=${query}`
                );
            console.log("App Version Response", response);
            
            if (response.success && response.success === true) {
                const updatedData = response.data.data.map((emp) => ({
                    ...emp,
                    showFullPath: false,
                }));
                updatedData.sort((a, b) => b.todayActiveStatus - a.todayActiveStatus);
                setEmployeeData(updatedData);
                setTotalRows(response.data.totalCount);
            }
        } catch (error) {
            HandleErrorMessage(error);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        const handler = setTimeout(() => {
            setDebouncedQuery(searchQuery);
                setCurrentPage(1)
        }, 500);

        return () => {
            clearTimeout(handler);
        };
    }, [searchQuery]);

    useEffect(() => {
        if (debouncedQuery.length >= 3 || debouncedQuery.length === 0) {
            fetchData(debouncedQuery);
        }
    }, [debouncedQuery, currentPage, perPage]);

    const handleSearch = (e) => {
        setSearchQuery(e.target.value);
    };

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    const handlePerRowsChange = (newPerPage, page) => {
        setPerPage(newPerPage);
        setCurrentPage(page);
    };

    return (
      <React.Fragment>
        <ToastContainer />
        <div className="page-content">
          <Container fluid>
            <BreadCrumb title="APP VERSION" pageTitle="Employee App Versions" />
            <div className="custom-datatable">
              <Row className="g-3 mt-0">
                <Col lg={12}>
                  <Card className="h-100">
                    <CardBody className="pt-0 sn-app-version-tble-data-main">

                      <div className="sn-backbtn mt-2">
                        <button
                          className="btn btn-sm border border-rounded shadow backbtn-main"
                          onClick={(e) => {
                            e.preventDefault();
                            navigate(-1);
                            // setTimeout(() => {
                            //   window.location.reload();
                            // }, 10); // Reload after 100ms
                          }}
                        >
                          <i className="ri-arrow-left-line m-1"></i> Back
                        </button>
                      </div>
                      <div
                        className="sales-ninja-tble-export-btn call-logs-report-export-exel mb-3"
                        style={{ position: "relative", top: "20px" }}
                      >
                        {" "}
                        <Button
                          onClick={handleExcelExport}
                          className="custom-button tble-export1"
                        >
                          <i className="ri-file-excel-line"></i>
                        </Button>{" "}
                      </div>
                      <CommanDataTables
                        perPage={perPage}
                        setCurrentPage={setCurrentPage}
                        column={columns}
                        tableData={employeeData}
                        handleSearch={handleSearch}
                        searchText={searchQuery}
                        handlePerRowsChange={handlePerRowsChange}
                        totalRows={totalRows}
                        currentPage={currentPage}
                        isLoading={isLoading}
                        handlePageChange={handlePageChange}
                        noData="There are no records to display"
                        pagination={true}
                      />
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </div>
          </Container>
        </div>
      </React.Fragment>
    );
};

export default AppVersion;
